import { GraphicWrapper } from './AustraliaBackgroundOutline.styles'
import Icon from './Icons'

const AustraliaBackgroundOutline = () => {
  return (
    <GraphicWrapper>
      <Icon name="australiaOutline" />
    </GraphicWrapper>
  )
}

export default AustraliaBackgroundOutline
